import { StartWrapper } from "./Start.style";
import React from "react";
import Link from "next/link";
import ContactForm from "../../components/Contact/ContactForm/ContactForm";
import { useMediaQuery } from "react-responsive";

export default function Start() {
  const isDesktop = useMediaQuery({ minWidth: 1024 });

  return (
    <StartWrapper>
      {isDesktop && (
        <div className="left">
          <Link href="/">
            <img src="/logo_easycapital_white.png" alt="EasyCapital Logo" />
          </Link>
        </div>
      )}
      <div className="right">
        <div className="description">
          <p className="sorry">Inscrivez-vous en avant-première &nbsp; 😃</p>
          <p>Nos équipes développent actuellement l'outil.</p>
          <p>
            Une poignée de nos clients l’utilisent afin de vous proposer la
            meilleure experience !
          </p>
          <p>
            <strong>
              Rejoignez-les et bénéficiez d'un accès privilégié de notre offre
              en ligne.
            </strong>
          </p>
        </div>
        <ContactForm />
      </div>
    </StartWrapper>
  );
}
